import React from 'react';
import Markdown from '../Markdown';
import styles from './ChatAnnouncement.scss';

interface ChatAnnouncementProps {
  imageUrl?: string;
  title?: string;
  content: string;
}

export default function ChatAnnouncement({ content, title, imageUrl }: ChatAnnouncementProps) {
  return (
    <div className={styles.ChatAnnouncement}>
      <div className={styles.ChatAnnouncement__header}>
        <img className={styles.ChatAnnouncement__logo} src="/img/logo_inverted.png" alt="Piczel.tv" />
        <span className={styles.ChatAnnouncement__label}>announcement:</span>
      </div>
      {imageUrl && (
        <img className={`${styles.ChatAnnouncement__image} dont-freeze`} src={imageUrl} alt={title} />
      )}
      {title && (
        <div className={styles.ChatAnnouncement__title}>{title}</div>
      )}

      <div className={styles.ChatAnnouncement__content}>
        <Markdown>
          {content}
        </Markdown>
      </div>
    </div>
  )
}